import React from 'react';
import { Portal } from 'react-portal';

import Dish from '../../Dish';


const primaryDishNodeMobile = document.querySelector('#tom-main-banner-portal-mobile');
const primarylDishNodeDesktop = document.querySelector('#tom-main-banner-portal-desktop');


export function DishCategoryPrimary(props) {
    const {
        colors,
        dishes,
        basketDishes,
        promoCheckoutDishObserver,
    } = props;

    const [dish] = dishes;
    const basketDish = basketDishes.find((bd) => {
        if (dish.isSet) {
            return dish.dishes.includes(bd.id);
        }
        return bd.id === dish.id;
    }) || { portion: 0 };

    return (
        <>
            <Portal node={primaryDishNodeMobile}>
                <Dish
                    index={0}
                    {...dish}
                    portion={basketDish.portion}
                    buttonsDisabled={false}
                    isFirstCategory={false}
                    isCentered={false}
                    canChangePortionsCount
                    areDetailsEnabled={false}
                    colors={colors}
                    promoCheckoutDishObserver={promoCheckoutDishObserver}
                    isNutritionEnabled={false}
                />
            </Portal>
            <Portal node={primarylDishNodeDesktop}>
                <Dish
                    index={0}
                    {...dish}
                    portion={basketDish.portion}
                    buttonsDisabled={false}
                    isFirstCategory={false}
                    isCentered={false}
                    canChangePortionsCount
                    areDetailsEnabled={false}
                    colors={colors}
                    promoCheckoutDishObserver={promoCheckoutDishObserver}
                    isNutritionEnabled={false}
                />
            </Portal>
        </>
    );
}
